import { Box, Theme, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { ReactNode } from "react";
import MobileHeader from "./components/MobileHeader";
import MobileFooter from "./components/MobileFooter";

const MobileMap = ({
  sx,
  children,
  ...props
}: {
  sx?: SxProps<Theme>
  children: ReactNode
}) => {
  const theme = useTheme();

  return (
    <Box
      {...props}
      sx={{
        borderRadius: { xs: "10px", md: "24px" },
        backgroundColor: theme.palette.common.white,
        boxShadow: "0px 2.5px 2px 0px rgba(0, 0, 0, 0.02), 0px 6px 5px 0px rgba(0, 0, 0, 0.03), 0px 11px 9px 0px rgba(0, 0, 0, 0.04), 0px 20px 16px 0px rgba(0, 0, 0, 0.04), 0px 37px 30px 0px rgba(0, 0, 0, 0.05)",
        boxSizing: "border-box",
        position: "absolute",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        ...sx
      }}
    >
      <MobileHeader />
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          flex: "1 1 auto"
        }}
      >
        {children}
      </Box>
      <MobileFooter />
    </Box>
  )
};

export default MobileMap;